// Session-52 8-color palette ported from DashboardGameViewPages.kt:292-302.
// Values vetted for >=4.5:1 contrast on --night-card (#1C1C2E) and hue-
// separated from semantic amber/red/green so an accidental teamName hash
// never masquerades as "winner" or "danger". Identical algorithm so the
// dashboard and the PWA pick the SAME color for the same team — organizer
// reading lobby-chat in the dashboard sees the same palette assignment as
// the player on their phone.
const TEAM_COLORS = [
  '#5AA9FF', '#FF7AB6', '#7FE3A1', '#C99CFF',
  '#FFC670', '#4ED8D0', '#E08AFF', '#A8B4FF',
];

const FALLBACK_COLOR = '#808094';

export function teamColor(name: string | null | undefined): string {
  if (!name) return FALLBACK_COLOR;
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h + name.charCodeAt(i)) % 1000000;
  return TEAM_COLORS[h % TEAM_COLORS.length];
}
